<template>
  <main class="mb-3">
    <topBg :title="'个人中心'"></topBg>
    <div class="container-lg max-width-1200 position-relative zindex-100 ">
      <div class="row g-2">
        <div class="col-md-3 col-12 d-block d-md-none " >
          <div
              @click="changeCollapse"
              data-bs-toggle="collapse" href="#collapseMenuid"
              class="top-rounded list-header d-flex align-content-center justify-content-center bg-primary py-3 lh-lg text-white">
            个人中心
            <i class="bi bi-chevron-double-down ps-1" v-if="!showList"></i>
            <i class="bi bi-chevron-double-up ps-1" v-else></i>
          </div>
          <div class="bg-white collapse bottom-rounded shadow-sm"   id="collapseMenuid" ref="choiseCollapseRef" >
            <router-link class="border-0 mb-1 list-group-item d-flex align-content-center py-2 px-4 justify-content-center lh-sm flex-shrink-0"
                         active-class="drop-link--Active"
                         :to="item.path"
                         v-for="(item,index) in centermenusList"
                         :key="index">
              {{item.name}}
            </router-link>
          </div>
          <div>
          </div>
        </div>
        <div class="col-md-3 col-12  d-none d-md-block" >
          <div
              class="top-rounded list-header d-flex align-content-center justify-content-center bg-primary py-3 lh-lg text-white">
            个人中心
          </div>
          <div class="bg-white bottom-rounded shadow-sm">
            <template v-for="(item,index) in centermenusList">
              <router-link class="border-0 mb-1 list-group-item d-flex align-content-center py-3 px-4 justify-content-center lh-sm flex-shrink-0"
                           active-class="drop-link--Active"
                           :to="item.path" >{{item.name}}</router-link>
            </template>

          </div>
          <div>
          </div>
        </div>

        <div class="col-md-9 col-12 bg-white shadow-sm rounded-3">
<!--          <router-view></router-view>-->
                     <RouterView v-slot="{ Component }">
                       <template v-if="isLogin">
                         <component
                             :is="Component"
                             view-prop="value"
                         />
                       </template>
                       <template v-else>
                         <div class="d-flex flex-column align-items-center justify-content-center py-4">
                           <button class="mt-4 btn btn-primary" @click="loginModelOpen(true)">立即登录</button>
                           <text class="small mt-2 text-secondary">无法查看信息，请登录</text>
                         </div>
                       </template>
                     </RouterView>
        </div>

      </div>
    </div>
  </main>

</template>

<script setup>
import {centermenusList} from "@/router/menusList"
import {ref, onUnmounted, onMounted, computed} from "vue";
import {Collapse} from "bootstrap";
// import store from "@/store";

const showList = ref(true)
const choiseCollapseRef = ref()
let choiseCollapse; // collapse实例
const isLogin = computed(()=>store.state.loginModel.login)
import {loginModelOpen} from "@/utils/authCheck"
import {useStore} from "vuex";
const store = useStore()


onUnmounted(()=>{
  if(choiseCollapse){
    choiseCollapse.dispose()
  }

})
onMounted(()=>{
  initCollapse()
})

const initCollapse = ()=> {
  if (!choiseCollapse && choiseCollapseRef.value) {
    choiseCollapse = new Collapse(choiseCollapseRef.value, {toggle: true})
    // choiseCollapse.show()
    console.log(3333,choiseCollapse)
  }
}



const changeCollapse = ()=>{
  initCollapse()
  if (showList.value) {
    // 关闭折叠
    choiseCollapse.hide();
  } else {
    // 展开折叠
    choiseCollapse.show();
  }
  showList.value = !showList.value;
}

</script>

<style scoped lang="scss">
.bg-top {
  position: relative;
}
.mt-n3{
  margin-top: -4rem !important;
}
//.drop-link--Active{
//
//}
.list-group-item:hover{
  background: rgb(242, 246, 253);
}
.drop-link--Active{
  font-weight: bold;
  background: rgb(242, 246, 253);
  position: relative;
  &:after{
    content: "";
    width:4px;
    background:#0d6efd;
    height: 100%;
    left: 0;
    top: 0;
    position:absolute;
  }
}
.top-rounded{
  border-radius:0.5rem 0.5rem 0 0;
}
.bottom-rounded{
  border-radius:0 0 0.5rem 0.5rem;
}
</style>
